'use client';

import { Heading } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

type QuizOptionColorProps = {
  colors: string[];
  label: string;
  labelId: string;
};

export function QuizOptionColor({
  colors,
  label,
  labelId,
}: QuizOptionColorProps) {
  return (
    <div aria-hidden="true" className={styles.container}>
      <div className={styles.colorGrid}>
        {colors.slice(0, 4).map((color) => (
          <span
            key={color}
            className={styles.colorCircle}
            style={{ backgroundColor: color }}
            aria-hidden="true"
          />
        ))}
      </div>
      <Heading
        aria-hidden="true"
        as="p"
        id={labelId}
        variant="sm"
        className={styles.label}
      >
        {label}
      </Heading>
    </div>
  );
}
